import { ANALYTICS_ANONYMOUS_ID } from 'src/constants/localStorage';
import {
    ACCESS_TOKEN_KEY,
    ACCESS_TOKEN_SOURCE_KEY,
    APP_ACTIVE_CONTEXT_KEY,
    IMPERSONATED_KEY,
    MCP_OAUTH_AUTHORIZATION_URL_KEY,
    MCP_OAUTH_STARTED_AT_MS_KEY,
} from 'src/constants/sessionStorage';
import { MOBILE_AUTH_SESSION_KEYS } from 'src/routes/Auth/mobileAuthSession';

const SESSION_STORAGE_KEYS = [
    APP_ACTIVE_CONTEXT_KEY,
    IMPERSONATED_KEY,
    ACCESS_TOKEN_KEY,
    ACCESS_TOKEN_SOURCE_KEY,
    'invited_vendor_token',
    'invitedVendorToken',
    ...Object.values(MOBILE_AUTH_SESSION_KEYS),
    MCP_OAUTH_AUTHORIZATION_URL_KEY,
    MCP_OAUTH_STARTED_AT_MS_KEY,
] as const;

interface BrowserSignOutDeps {
    clearCookie: () => void;
    removeSessionItem: (key: string) => void;
    removeLocalItem: (key: string) => void;
    redirect: () => void;
}

const attempt = (operation: () => void): void => {
    try {
        operation();
    } catch {
        // Logout and its redirect must continue when browser storage is restricted.
    }
};

export const finishBrowserSignOut = ({
    clearCookie,
    removeSessionItem,
    removeLocalItem,
    redirect,
}: BrowserSignOutDeps): void => {
    try {
        attempt(clearCookie);
        SESSION_STORAGE_KEYS.forEach((key) => attempt(() => removeSessionItem(key)));
        attempt(() => removeLocalItem(ANALYTICS_ANONYMOUS_ID));
    } finally {
        redirect();
    }
};
